import { POST_GET_ALL_ITEMS_POST, REQUISITION_LOG_URL, REQUISITION_URL } from '../../CONSTANTS';
import { SYSTEM_ERROR } from '../../config/CONSTANTS';
import axios from 'axios';
import Cookies from 'universal-cookie';

const cook = new Cookies().get('loginData1');

const headersdata = {
    'content-type': 'application/json',
    Accept: 'application/json',
    Authorization: cook !== undefined ? cook.accessToken : '',
};

const callPostAxios = (URL, data) => {
    return new Promise((resolve, reject) => {
        try {
            axios.post(URL, data, { headers: headersdata }).then((res) => {
                resolve(res.data);
            });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

const callGetAxios = (URL) => {
    return new Promise((resolve, reject) => {
        try {
            axios.get(URL, { headers: headersdata }).then((res) => {
                resolve(res.data);
            });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

const callPutAxios = (URL, data, errorFlag) => {
    return new Promise((resolve, reject) => {
        try {
            axios
                .put(URL, data, { headers: headersdata })
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(`Error in ${errorFlag} axios!`);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const getRequisitionList = (data) => {
    return callPostAxios(REQUISITION_URL() + 'getAllRecords', data);
};

export const getRequisitionUUID = (id) => {
    return callGetAxios(REQUISITION_URL() + id)
};

export const GET_ALL_ITEMS_FOR_ISSUANCE = (data) => {
    return callPostAxios(POST_GET_ALL_ITEMS_POST, data);
}

export const addRequisition = (data) => {
    return callPostAxios(REQUISITION_URL(), data)
};

export const getPendingRequisition = (data) => {
    return callPostAxios(REQUISITION_URL() +'getRequisitionsByWarehouse', data);
};

export const getRequisitionLogHistory = (id) => {
    return callGetAxios(REQUISITION_LOG_URL() +"getRequisitionHistory/" + id)
};

export const updateRequisition = (id, data) => {
    return callPutAxios(REQUISITION_URL() + id, data, "updateInvoiceDetailsByUUID")
}

export const acceptRejectRequisition = (id, flag) => {
    return callPutAxios(REQUISITION_URL() + id + "/" + flag, {}, "acceptRejectRequisition")
}
export const addPrintLogHistory = (id) => {
    return callPostAxios(REQUISITION_URL() + "log-print/" + id, {})
}

export const handleRequisitionActiveInactive=(id)=>{
    return callPutAxios(REQUISITION_URL()  + "activeOrDeActiveRequisition/"+id,)
}